import type { ProductPropertiesKeyAPI } from '~/api/Catalog';
import type { ProductPropertyFilter } from '~/stores/CatalogStore';
import { DISCOUNTED_PARAM } from '~/stores/CatalogStore/discountedParam';

export const ignoreParams = [
  'sorting',
  'sortingDir',
  'priceFrom',
  'priceTo',
  'modal',
  'editAddress',
  'page',
  'showProducts',
  DISCOUNTED_PARAM,
  // Marketing / tracking params — must not be treated as product filters
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
  'fbclid',
  'gclid',
  'gclsrc',
  'gbraid',
  'wbraid',
  'gad_source',
  'gad_campaignid',
  '_gl',
  'srsltid',
  'dclid',
  'msclkid',
  'twclid',
  'ttclid',
  'li_fat_id',
  'mc_cid',
  'mc_eid',
  'yclid',
  '_ga',
  'ref',
];

/**
 * Turns every query param outside `ignoreParams` into a product property filter.
 * A tracking param missing from the list becomes a filter no product matches
 * and empties the catalog (Google's `srsltid` on organic results did exactly that).
 */
export const parseProperties = (searchParams: URLSearchParams) => {
  return Array.from(searchParams.keys()).reduce((acc, key) => {
    if (ignoreParams.includes(key)) {
      return acc;
    }

    return {
      ...acc,
      [key as ProductPropertiesKeyAPI]: searchParams
        .getAll(key)
        .flatMap((param) => param.split(',')),
    };
  }, {} as ProductPropertyFilter);
};
